import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {ApiErrors, StoreLoadingEnum} from 'types/global';
import {createApiError} from 'helpers/global';
import {notificationApi} from "api/notification";
import {RootState} from "store";
import {GeneralEmailNotificationDto, NotificationQueryParams} from "types/notifications";

interface NotificationDto {
    loading: StoreLoadingEnum;
    error: string | null;
    data: GeneralEmailNotificationDto | null;
}

const initialState: NotificationDto = {
    loading: StoreLoadingEnum.idle,
    error: null,
    data: null,
}
export const notificationThunk = createAsyncThunk<
    GeneralEmailNotificationDto,
    NotificationQueryParams,
    { rejectValue: ApiErrors }
>(
    'notification/get',
    async (data, thunkAPI) => {
        try {
            return await notificationApi.getOne(data);
        } catch (e) {
            return thunkAPI.rejectWithValue(createApiError(e));
        }
    }
);

export const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        reset: (state) => Object.assign(state, initialState),
    },
    extraReducers: (builder) => {
        builder.addCase(notificationThunk.pending, (state) => {
            state.data = null;
            state.loading = StoreLoadingEnum.pending;
            state.error = null;
        });
        builder.addCase(notificationThunk.fulfilled, (state, action) => {
            state.data = action.payload;
            state.loading = StoreLoadingEnum.loaded;
            state.error = null;
        });
        builder.addCase(notificationThunk.rejected, (state, action) => {
            state.data = null;
            state.loading = StoreLoadingEnum.loaded;
            state.error = action.payload?.message || null;
        });
    },
});

export const selectNotificationData = (state: RootState) => state.notification.data;
export const selectNotificationLoading = (state: RootState) => state.notification.loading;
export const selectNotificationError = (state: RootState) => state.notification.error;